"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DbAssignmentSettingsSchema = void 0;
const zod_1 = require("zod");
// Original: https://github.com/lessonup/lessonup/blob/a3ac598bc65668a5d456f348e2e8ac9ac3eec5b1/libs/lessonup-core/src/domain/assignment/Assignment.ts
exports.DbAssignmentSettingsSchema = zod_1.z.object({
    _id: zod_1.z.string(),
    createdAt: zod_1.z.number(),
    currentView: zod_1.z.object({
        foregroundPinId: zod_1.z.string(),
        params: zod_1.z.any(),
        pinId: zod_1.z.string(),
    }),
    modifiedAt: zod_1.z.number(),
    ownerId: zod_1.z.string(),
    pincode: zod_1.z.string().nullable(), // TODO: Extract union for open and closed assignments?
    nextAssignmentId: zod_1.z.string().nullish(),
    nextAssignmentVersion: zod_1.z.enum(['v2']).nullish(),
    playerSettings: zod_1.z.object({
        allowConnectedDevices: zod_1.z.boolean(),
        allowNewPlayers: zod_1.z.boolean(),
        autoShowRank: zod_1.z.boolean(),
        ignoreExclusions: zod_1.z.boolean(),
        isPrepScreenEnabled: zod_1.z.boolean(),
        isRaiseHandAllowed: zod_1.z.boolean(),
        isScreenShared: zod_1.z.boolean(),
        isSoundEnabled: zod_1.z.boolean(),
    }),
    status: zod_1.z.enum(['open', 'closed']),
    type: zod_1.z.enum(['realtime']),
    visibility: zod_1.z.enum(['all']),
});
//# sourceMappingURL=db-assignment-settings.js.map